/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_At_PriceInputs */

const en_compare_at_price = /** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare at price`)
};

const es_compare_at_price = /** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio de comparación`)
};

const fr_compare_at_price = /** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix de comparaison`)
};

const de_compare_at_price = /** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleichspreis`)
};

const id_compare_at_price = /** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga perbandingan`)
};

/** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */
const ja_compare_at_price = en_compare_at_price;

/** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */
const zh_compare_at_price = en_compare_at_price;

/** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */
const ar_compare_at_price = en_compare_at_price;

/** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */
const it_compare_at_price = en_compare_at_price;

/** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */
const ru_compare_at_price = en_compare_at_price;

/** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */
const pt_compare_at_price = en_compare_at_price;

/** @type {(inputs: Compare_At_PriceInputs) => LocalizedString} */
const ko_compare_at_price = en_compare_at_price;

/**
* | output |
* | --- |
* | "Compare at price" |
*
* @param {Compare_At_PriceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const compare_at_price = /** @type {((inputs?: Compare_At_PriceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_At_PriceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_compare_at_price(inputs)
	if (locale === "es") return es_compare_at_price(inputs)
	if (locale === "fr") return fr_compare_at_price(inputs)
	if (locale === "de") return de_compare_at_price(inputs)
	if (locale === "ja") return ja_compare_at_price(inputs)
	if (locale === "zh") return zh_compare_at_price(inputs)
	if (locale === "ar") return ar_compare_at_price(inputs)
	if (locale === "id") return id_compare_at_price(inputs)
	if (locale === "it") return it_compare_at_price(inputs)
	if (locale === "ru") return ru_compare_at_price(inputs)
	if (locale === "pt") return pt_compare_at_price(inputs)
	return ko_compare_at_price(inputs)
});